import { api } from './api';

export const calendarService = {
  getTasks: async () => {
    try {
      return await api.get('/api/calendar/tasks');
    } catch (firstError) {
      console.warn('getTasks /api failed, fallback to /api/calendar/tasks', firstError);
      try {
        return await api.get('/api/calendar/tasks');
      } catch (secondError) {
        console.error('Error fetching tasks:', secondError);
        throw secondError;
      }
    }
  },

  createTask: async (taskData) => {
    try {
      return await api.post('/api/calendar/tasks', taskData);
    } catch (firstError) {
      console.warn('createTask /api failed, fallback to /calendar/tasks', firstError);
      return await api.post('/calendar/tasks', taskData);
    }
  },

  updateTask: async (taskId, updateData) => {
    try {
      return await api.patch(`/api/calendar/tasks/${taskId}`, updateData);
    } catch (firstError) {
      console.warn('updateTask /api failed, fallback to /calendar', firstError);
      return await api.patch(`/calendar/tasks/${taskId}`, updateData);
    }
  },

  notifyTask: async (taskId) => {
    try {
      return await api.post(`/api/calendar/tasks/${taskId}/notify`, {});
    } catch (firstError) {
      console.warn('notifyTask /api failed, fallback to /calendar', firstError);
      return await api.post(`/calendar/tasks/${taskId}/notify`, {});
    }
  }
};

// Also provide named exports for callers that import functions directly
export const getTasks = (...args) => calendarService.getTasks(...args);
export const createTask = (...args) => calendarService.createTask(...args);
export const updateTask = (...args) => calendarService.updateTask(...args);
export const notifyTask = (...args) => calendarService.notifyTask(...args);
